type Cell = { text: string; opacity: number } | null

/** Rows of tinted cells (retention, weekly reading). Opacity carries the value; the text keeps it readable without colour. */
export function HeatGrid({ rows, columns, ariaLabel }: {
  rows: { label: string; cells: Cell[] }[]
  columns: string[]
  ariaLabel: string
}) {
  return (
    <div className="overflow-x-auto">
      <table role="table" aria-label={ariaLabel} className="font-mono text-[11px] text-paper border-separate" style={{ borderSpacing: 2 }}>
        <thead>
          <tr>
            <th className="label text-left font-normal pr-3" />
            {columns.map((c) => <th key={c} className="label font-normal text-center px-1">{c}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label}>
              <th scope="row" className="label text-left font-normal pr-3 whitespace-nowrap">{r.label}</th>
              {r.cells.map((c, i) => (
                <td
                  key={i}
                  className="text-center min-w-[44px] h-7 px-1"
                  style={c ? { background: `rgba(255, 182, 72, ${c.opacity})`, color: c.opacity > 0.55 ? '#111' : undefined } : undefined}
                >
                  {c?.text ?? ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
